import { useEffect, useState } from "react";

import { getPilotoStatus } from "src/services/gestionAusencia";

// Hook que consulta al backend si el usuario autenticado esta dentro del piloto
// del motor de gestion de ausencias (fiscal piloto + sus operarios vigentes).
//
// Usado por BannerActivarNotificaciones para decidir si mostrar el aviso.
// Si el backend falla, retorna enPiloto=false (degradacion silenciosa).
export const usePilotoStatus = () => {
  const [enPiloto, setEnPiloto] = useState(false);
  const [cargado, setCargado] = useState(false);

  useEffect(() => {
    let cancelado = false;
    (async () => {
      try {
        const status = await getPilotoStatus();
        if (!cancelado) setEnPiloto(Boolean(status?.en_piloto));
      } catch {
        if (!cancelado) setEnPiloto(false);
      } finally {
        if (!cancelado) setCargado(true);
      }
    })();
    return () => {
      cancelado = true;
    };
  }, []);

  return { enPiloto, cargado };
};
